import { useState } from 'react'
import { Document, Page, PDFViewer, View, Text, StyleSheet, PDFDownloadLink, Image, pdf } from '@react-pdf/renderer'
import { Boton, Spinner } from "asocomponents"
import EmailServices from '../../../../modules/Email/application/EmailServices'
import { WEBURLEGALES } from "../../../helpers/frontend.js"
import { mostrarMensaje } from '../../../helpers/mensajeria.js'
import { obtenerApoderado, blobToHex } from '../../../helpers/funciones.js'
import { MENSAJESAPP } from '../../../const/constantes.js'

const PDFViewer1 = ({ correo, correoCC, monto, matricula, letrado, expediente, comision, trabajador, apoderado, direccion, montoLetras }) => {

  const [loading, setLoading] = useState(false)

  const fileName = `CONVENIO_HON_${trabajador.replace(/\s/g, '_')}_EXPTE_${expediente.replace(/[\s\/]/g, '_').trim()}.pdf`

  //const montoFormato= monto.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  const obtenerNombreApoderado = () => {
    console.log(apoderado)
    const apoderadoAso = obtenerApoderado(apoderado)
    console.log(apoderadoAso)

    return apoderadoAso ? apoderadoAso.nombre + ' DNI: ' + apoderadoAso.dni : null
  }

  const obtenerFirma = () => {
    const firma = obtenerApoderado(apoderado)
    return firma ? firma.path : null
  }

  //Funcion para trasnformar la fecha en palaras
  const formatDate = (date) => {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]

    const day = date.getDate()
    const month = months[date.getMonth()]
    const year = date.getFullYear()

    return `${day} de ${month} de ${year}`
  }

  const today = new Date()
  const formattedDate = formatDate(today)


  const padToMultipleOf500 = (inputText) => {
    const padLength = 100
    const padding = '-'.repeat(padLength)

    return inputText + padding
  }

  // Create styles
  const styles = StyleSheet.create({
    page: {
      paddingTop: 10,
      paddingRight: 20,
      paddingLeft: 20,
      paddingBottom: 40,
      fontFamily: 'Times-Roman'
    },
    section: {
      fontSize: 10,
      padding: 15,
      lineHeight: 2,
      textAlign: "justify",
      fontFamily: 'Times-Roman',
    },
    titulo: {
      fontSize: 12,
      textAlign: "center",
      marginTop: 20,
      height: 50,
      fontWeight: 900,
      textDecoration: 'underline',
    },
    viewer: {
      width: 700,
      height: 400,
      '@media max-width: 400': {
        width: 700,
      },
      '@media orientation: landscape': {
        width: 700,
      },
    },
    firmas: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: 50,
    },
    firma: {
      textAlign: 'center',
      width: '40%',
      marginHorizontal: 40,
    },
    firmaImagen: {
      width: 150,
      height: 100,
      marginBottom: 15,
    },
    firmaTexto: {
      fontSize: 10,
      fontWeight: 'bold',
      textDecoration: 'underline',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  })

  const sendEmail = async (event) => {
    setLoading(true)
    try {
      event.preventDefault()

      const asunto = `CONVENIO HONORARIOS ${trabajador.trim()} EXPTE. SRT ${expediente.trim()}`

      const cuerpo = `<html><div>Estimado/a:<br><br>Le remitimos convenio de honorarios e instrucciones para la facturación. Una vez que se notifique a las partes la homologación del acuerdo arribado, usted estará en condiciones de remitir a esta parte la factura por sus honorarios de acuerdo al convenio adjunto. <span style="background-color: yellow; color: black;">Para percibir el cobro, usted deberá presentar a través del portal web </span> <b><a href="https://facturacionsh.asociart.com.ar"/>https://facturacionsh.asociart.com.ar</a></b>  <span style="background-color: yellow; color: black;">la siguiente documentación.</span><br><br>
    <ul style="list-style-type: circle"><li><b>Convenio de honorarios firmado</b></li><br><br><li><b>Factura “B” + IVA </b> (si es Responsable Inscripto) o <b>Factura “C”</b> (si es Monotributista) por el importe convenido.</li><br>
    El CUIT de Asociart SA ART es 30-68627333-0 y la Condición frente al IVA de Asociart es EXENTO.<br><br><li><b>Constancia vigente de Inscripción en AFIP.</b></li><br><br><li><b>Constancia vigente de Inscripción en Ingresos Brutos</b> (en caso de que esté inscripto en dicho tributo). Local o Padrón Web si está inscripto en Convenio Multilateral. Para este último, también deberá remitir ultimo formulario CM05 presentado.</li><br><br>
    <li><b>Constancia de exenciones o exclusiones de retención</b> (de corresponder).<br><br><li><b>Constancia de CBU </b>(mismo titular quien factura) para transferir oportunamente los honorarios directamente a su cuenta.</li><br><br>
    <li><b>Cesión de honorarios: </b>En caso de que usted ceda sus honorarios a un colega, nos deberá adjuntar la cesión firmada por ambos profesionales.</li></ul><br><br>
    Le recordamos <b>se abonará dentro de los 30 días corridos de presentada a través del portal web la facturación junto con la documentación impositiva requerida.</b><br><br>
    Atte.<br>ASOCIART S.A. ART</div></html>`

      setLoading(true)
      const pdfBlob = await pdf(MyDocument()).toBlob()

      // Convertir el PDF a hexadecimal
      const hexString = await blobToHex(pdfBlob)

      const emailServices = new EmailServices()
      const result = await emailServices.enviarEmailAdjunto('facturacionsh@asociart.com.ar', correo, correoCC, asunto, cuerpo, fileName, 'pdf', hexString)

      mostrarMensaje(MENSAJESAPP.CONFIRMACION.CORREOENVIADOOK, "success", "2000")
    }
    catch (e) {
      mostrarMensaje(MENSAJESAPP.ERRORES.ERRORENVIARCORREO, "error", "2000")
      console.log(e)
    }
    finally {
      setLoading(false)
    }
  }

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.titulo}>
          <Text>ACUERDO DE HONORARIOS PROFESIONALES</Text>
        </View>
        <View style={styles.section}>
          <Text>
            {padToMultipleOf500(`${letrado}, (en adelante “el letrado”), MATRICULA ${matricula}, constituyendo domicilio en la calle ${direccion} y ${obtenerNombreApoderado()} en representación de ASOCIART S.A. ASEGURADORA DE RIESGOS DEL TRABAJO, (en adelante “Asociart”) con domicilio en Av. Alem 621 CABA, celebran el presente acuerdo de honorarios profesionales, el cual se regirá por las disposiciones contenidas en las cláusulas que se detallan a continuación.`)}
          </Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`PRIMERA: De conformidad a lo dispuesto por el artículo 1 de la Ley 27.348, el letrado ha representado a ${trabajador} en el procedimiento desarrollado en el marco expediente Nro. ${expediente} en trámite por ante la Comisión Médica ${comision}. En dicho expediente, Asociart y el trabajador acordaron una propuesta de convenio y la sometieron a la consideración del titular del Servicio de Homologación de la Comisión Médica. Para el caso de que se disponga la homologación del acuerdo formulado con autoridad de cosa juzgada administrativa, en los términos del artículo 15 de la Ley 20.744, Asociart abonará al letrado la suma única y total de $${monto} (PESOS ${montoLetras}) más I.V.A. (de corresponder) en concepto de honorarios profesionales por la totalidad de las gestiones realizadas en relación al procedimiento referido en esta cláusula.`)}</Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`SEGUNDA: La suma de dinero referida en la cláusula PRIMERA será abonada por Asociart al letrado a través de transferencia bancaria a los 30 días contados a partir de la presentación de la factura. Tener presente que la condición ante IVA del Asociart ART S.A. es Exento. La factura, documentación impositiva para su alta en el sistema y CBU bancario para efectivizar el pago deberá ser presentado por el portal web https://facturacionsh.asociart.com.ar`)}</Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`TERCERA: El presente acuerdo de honorarios quedará sin efecto en el caso de que, por cualquier causa, el Servicio de Homologación rechace la homologación del acuerdo referido en la cláusula PRIMERA y/o intervenga en el procedimiento referido en dicha cláusula otro abogado en representación y/o patrocinio del trabajador. De acontecer cualquiera de los dos supuestos, el letrado manifiesta que nada tendrá que reclamar a Asociart por su actuación profesional.`)}</Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`CUARTA: Una vez que el letrado perciba el pago establecido en la cláusula PRIMERA, nada más tendrá que reclamar a Asociart en concepto alguno por su actuación profesional en el marco del procedimiento detallado en el presente acuerdo.`)}</Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`QUINTA: A todos los efectos del presente acuerdo, las partes se someten en forma excluyente a la jurisdicción de los Juzgados de Primera Instancia en lo Laboral y constituyen los domicilios indicados en el encabezado, donde serán plenamente válidas todas las notificaciones cursadas.`)}</Text>
        </View>
        <View style={styles.section}>
          <Text>{padToMultipleOf500(`En prueba de conformidad, las partes firman dos ejemplares de igual tenor y a un mismo efecto en la ciudad de Buenos Aires en fecha ${formattedDate} `)}</Text>
        </View>
        <View style={styles.firmas}>
          <View style={styles.firma}>
            <Image src={`${WEBURLEGALES}/firmas/${obtenerFirma()}`} style={styles.firmaImagen} />
            <Text style={styles.firmaTexto}>Firma Apoderado ART</Text>
          </View>
          <View style={styles.firma}>
            <Image src="/path/to/firma-letrado.png" style={styles.firmaImagen} />
            <Text style={styles.firmaTexto}>Firma Letrado Trabajador</Text>
          </View>
        </View>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  )

  return (
    <>
      <div className="mb-3 flex flex-row">
        <PDFDownloadLink
          document={MyDocument()}
          fileName={fileName}
        >
          {({ loading }) => <Boton texto={loading ? 'Cargando documento...' : 'Descargar PDF'} fondo="gris" />}
        </PDFDownloadLink>
        <div className="ml-3">
          {loading ? <Spinner size="20" color="red" /> : <Boton texto='Enviar por Correo' fondo="gris" onClick={sendEmail} />}
        </div>
      </div>
      <div>
        <PDFViewer style={styles.viewer}>
          {MyDocument()}
        </PDFViewer>
      </div>
    </>
  )
}

export default PDFViewer1